module.exports = __webpack_public_path__ + "static/media/tuberia-conduit-cople-pared-delgada.7493f06d.jpg";